import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import DashboardLayout from "../Components/DashboardLayout/DashboardLayout";
import { privateAxios } from "../../config/apiConfig";
import Loader from "../../User/Components/Loader/Loader";
import NotAuthorized from "../../Common/NotAuthorized";
import menuConfig from "../../config/MenuConfig";

const EmployeeRouter = () => {
  const [allowedUrls, setAllowedUrls] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const token = localStorage.getItem("jwt");
        if (!token) {
          setAllowedUrls([]);
          return;
        }

        const headers = { Authorization: `Bearer ${token}` };
        const response = await privateAxios.get("admin/group-maps/user", { headers });

        const groupMap = response.data;

        // 🔹 Extract allowed URLs where permission is READ or WRITE
        const urls = (groupMap.groupPermissions || [])
          .filter(gp => ["READ", "WRITE"].includes(gp.permission?.permissionName))
          .map(gp => gp.feature?.url)
          .filter(Boolean); // remove null/undefined

        setAllowedUrls(urls);
      } catch (error) {
        setAllowedUrls([]); // fallback: nothing
      } finally {
        setLoading(false);
      }
    };

    fetchPermissions();
  }, []);


  return (
    <DashboardLayout>
      <Routes>
        {menuConfig.map(({ path, component: Component, category }) => {
          // Prefix /admin routes with /employee
          const routedPath = path.startsWith("/admin")
            ? `/employee${path}`
            : path.startsWith("/vendor")
              ? `/employee${path}`
              : path;

          // Remove leading /employee/ for Route `path` prop
          const relativePath = routedPath.replace(/^\/employee\//, "");

          const canAccess =
            category === "Employee" || allowedUrls.includes(path);

          return (
            <Route
              key={routedPath}
              path={relativePath}
              element={
                canAccess
                  ? <Component />
                  : loading ? <Loader /> : <NotAuthorized />
              }
            />
          );
        })}
        {/* Fallback route if no match */}
        <Route path="*" element={<Navigate to="/employee" />} />
      </Routes>
    </DashboardLayout>
  );
};

export default EmployeeRouter;
